import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M27.467 96.764c-.88.397-7.282 6.448-14.226 13.446C2.57 120.964.56 123.236.256 124.892c-.835 4.555-4.012 1.117 63.123 68.308l62.748 62.8-62.763 62.8C7.997 374.201.56 381.831.249 383.558c-.759 4.218-.42 4.689 13.273 18.459 13.751 13.828 14.671 14.5 18.827 13.751 1.85-.334 8.199-6.514 64.851-63.132l62.8-62.763 62.8 62.763c56.652 56.618 63.001 62.798 64.851 63.132 4.154.749 5.077.076 18.841-13.751 10.923-10.972 12.948-13.25 13.252-14.909.835-4.555 4.012-1.117-63.123-68.308L193.873 256l62.763-62.8c56.618-56.652 62.798-63.001 63.132-64.851.749-4.154.076-5.077-13.751-18.841-10.972-10.923-13.25-12.948-14.909-13.252-4.555-.835-1.117-4.012-68.309 63.124l-62.801 62.749-62.532-62.507c-35.47-35.455-63.182-62.748-64.034-63.065-1.999-.742-4.018-.672-5.965.207"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "close"}) } }